import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { ForgotComponent } from "./forgot/forgot.component";
import { ResetComponent } from "./reset/reset.component";

import { AdminComponent } from "./admin/admin.component";
import { SystemlogComponent } from "./admin/systemlog/systemlog.component";
import { UserManagementComponent } from "./admin/user-management/user-management.component";
import { ConfigManagementComponent } from "./admin/config-management/config-management.component";
import { AssetManagementComponent } from "./admin/asset-management/asset-management.component";

import { OrgadminComponent } from "./orgadmin/orgadmin.component";
import { FleetManagementComponent } from "./orgadmin/fleet-management/fleet-management.component";
import { OrglogComponent } from "./orgadmin/orglog/orglog.component";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardDefaultComponent } from "./dashboard/dashboard-default/dashboard-default.component";
import { AccountComponent } from "./dashboard/account/account.component";
import { SupportComponent } from "./dashboard/support/support.component";

import { FleetComponent } from "./dashboard/fleet/fleet.component";
import { FleetDefaultComponent } from "./dashboard/fleet/fleet-default/fleet-default.component";

import { AssetComponent } from "./dashboard/fleet/asset/asset.component";

import { AuthGuardService, AuthGuardOrgAdminService, AuthGuardGlobalAdminService, AuthGuardMasterService } from "./auth-guard.service";
import { MasterAdminComponent } from "./admin/master-admin/master-admin.component";

const appRoutes: Routes = [
	{
		path: "",
		redirectTo: "/dash",
		pathMatch: "full"
	},
	{ path: "login", component: LoginComponent },
	{ path: "forgot", component: ForgotComponent },
	{ path: "reset", component: ResetComponent },
	{
		path: "admin",
		component: AdminComponent,
		canActivate: [AuthGuardGlobalAdminService],
		children: [
			{ path: "log", component: SystemlogComponent },
			{ path: "user", component: UserManagementComponent },
			{ path: "config", component: ConfigManagementComponent },
			{ path: "assets", component: AssetManagementComponent },
			{
				path: "master",
				component: MasterAdminComponent,
				canActivate: [AuthGuardMasterService],
			},
		],
	},
	{ path: "manage", redirectTo: "/orgadmin/manage" },
	{
		path: "orgadmin",
		component: OrgadminComponent,
		canActivate: [AuthGuardOrgAdminService],
		children: [
			{ path: "manage", component: FleetManagementComponent },
			{ path: "log", component: OrglogComponent },
		],
	},
	{
		path: "dash",
		component: DashboardComponent,
		canActivate: [AuthGuardService],
		children: [
			{ path: "", component: DashboardDefaultComponent },
			{ path: "account", component: AccountComponent },
			{ path: "support", component: SupportComponent },
			{
				path: "fleet/:fleetid",
				component: FleetComponent,
				children: [
					{ path: "", component: FleetDefaultComponent },
					{
						path: "asset/:assetid",
						component: AssetComponent,
					},
				]
			},
		]
	},
	{ path: "**", redirectTo: "/dash" }
];

@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes)
	],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule { }
